import MailModule from './MailModule';
import React from 'react';
import strings from 'owa-strings/owa-mini-common-strings';
import { AriaLiveWrapper } from 'mini-accessibility';
import { BrowserRouter as Router } from 'mini-react-router-dom';
import { getMailPath } from 'owa-url';
import { lazyRegisterMailWorkflowConfigs } from 'mini-mail-workflow-config';
import { MiniNavigationContextProvider } from 'mini-navigation/lib/MiniNavigationContext';
import { observer } from 'mobx-react-lite';
import { useRefreshMailListOnVisibilityChange } from './useRefreshMailListOnVisibilityChange';
import { useRegisterWorkflowConfigs } from 'mini-app-context/lib/hooks/useRegisterWorkflowConfigs';

/**
 * Component which serves as a wrapper over the main mail module component
 * All the components which need to be fetched on boot but need not be shown for optimization purpose can be added inside the
 * div with display:'none to ensure that the component is already loaded when it needs to be invoked
 * Please note that this will load the component on boot time, adding some delay there instead of later
 *
 * @param props
 */
/* eslint-disable-next-line @typescript-eslint/no-unused-vars --
 * See aka.ms/mini-lint-errors
 *	> 'props' is defined but never used. */
export default observer(function MailModuleWrapper(props: {}): JSX.Element {
    const wrapperRef = React.createRef<HTMLDivElement>();

    // register workflow configs
    useRegisterWorkflowConfigs(lazyRegisterMailWorkflowConfigs.importAndExecute);

    // refresh mail-list data if the app was in the background for a long time
    useRefreshMailListOnVisibilityChange();

    return (
        <div ref={wrapperRef} tabIndex={0} role="main" aria-label={strings.moduleMailLabel}>
            <Router basename={getMailPath()}>
                <MiniNavigationContextProvider>
                    <MailModule />
                    <AriaLiveWrapper />
                </MiniNavigationContextProvider>
            </Router>
        </div>
    );
});
